







import Vue from "vue";
import Navigation from '@/components/Navigation.vue';
import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyCo6EYVMTef9slaGT7S1GxRM949fneqvvI",
    authDomain: "qa-admin-12b5d.firebaseapp.com",
    databaseURL: "https://qa-admin-12b5d.firebaseio.com",
    projectId: "qa-admin-12b5d",
    storageBucket: "qa-admin-12b5d.appspot.com",
    messagingSenderId: "1000034905387",
    appId: "1:1000034905387:web:3ed910920e60635423a96e"
  };
  // Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default Vue.extend({
  name: "App",
 

  components: {
    Navigation
  },

  data: () => ({
    //
  })
});
